import { render } from "./EventVideoRoom.vue.js?vue&type=template&id=56b2a5c2!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./EventVideoRoom.vue?vue&type=template&id=56b2a5c2"
import script from "./EventVideoRoom.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./EventVideoRoom.vue?vue&type=script&lang=js"
export * from "./EventVideoRoom.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./EventVideoRoom.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-pages/event-page/EventVideoRoom.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "56b2a5c2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('56b2a5c2', __exports__)) {
    api.reload('56b2a5c2', __exports__)
  }
  
  module.hot.accept("./EventVideoRoom.vue.js?vue&type=template&id=56b2a5c2!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./EventVideoRoom.vue?vue&type=template&id=56b2a5c2", () => {
    api.rerender('56b2a5c2', render)
  })

}


export default __exports__